module.exports = __webpack_public_path__ + "0d5873325e938f6fac4dd2297c69d610.png";